import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useNavigation, pagePathOf } from '../../context/NavigationContext';

/** Shown while the first navigation tree of a session loads. */
export const NavLoading = () => (
  <div className="stui-loading"><Loader2 size={16} className="stui-spinner" /> Loading…</div>
);

/**
 * NavGuard — a page that has a navigation row opens when the server marked that row open in the
 * person's tree (the server's rule decided). The row is found by the page's own path, so the route
 * names no permission key.
 */
export const NavGuard = ({ children }) => {
  const { ready, canOpen } = useNavigation();
  const location = useLocation();
  if (!ready) return <NavLoading />;
  return canOpen(pagePathOf(location.pathname)) ? children : <Navigate to="/access-denied" replace />;
};
